import React, {PureComponent} from "react"
import CopyToClipboard from "react-copy-to-clipboard"

import Button from "@irati/ui/src/Button"
import Hr from "@irati/ui/src/Layout/Hr"

import {StyledCopy} from "./styled"

interface Props {
  redemptionCode: string,
  text: string
}

export default class CopyButton extends PureComponent<Props> {
  render() {
    const {redemptionCode, text} = this.props
    return (
      <>
        <StyledCopy>
          <Hr />
          <CopyToClipboard text={redemptionCode}>
            <Button full small>
              {text}
            </Button>
          </CopyToClipboard>
        </StyledCopy>
      </>
    )
  }
}
